import React from 'react';
import ProfileLevelPicker from '../ProfileLevelPicker';
import { parseWorkoutsPerWeek } from '../../constants/workoutWizardSteps';
import { syncWorkoutsPerWeekToForm } from '../../utils/wizardFormFromUser';

const WORKOUT_OPTIONS = [2, 3, 4];

export default function WizardStepProfile({ formData, onChange }) {
  const wpw = parseWorkoutsPerWeek(formData.workoutsPerWeek) || 3;

  const patch = (partial) => onChange({ ...formData, ...partial });

  const setWorkoutsPerWeek = (n) => {
    onChange(syncWorkoutsPerWeekToForm(formData, String(n)));
  };

  return (
    <div className="space-y-5">
      <div>
        <p className="font-mono text-[10px] uppercase tracking-wider text-iron-accent">Perfil atlético</p>
        <p className="mt-1 text-xs text-iron-muted">
          Nível e quantos treinos por semana quer no pack inicial.
        </p>
      </div>

      <ProfileLevelPicker
        value={formData.level}
        onChange={(level) => patch({ level })}
      />

      <div>
        <label className="section-label mb-2 block">Treinos por semana</label>
        <p className="mb-2 text-xs text-iron-muted">
          Define quantos treinos a IA vai propor no pack (2–4).
        </p>
        <div className="flex gap-2">
          {WORKOUT_OPTIONS.map((n) => {
            const active = wpw === n;
            return (
              <button
                key={n}
                type="button"
                onClick={() => setWorkoutsPerWeek(n)}
                className={`flex-1 rounded-lg border px-3 py-3 font-mono text-sm transition-colors ${
                  active
                    ? 'border-iron-accent bg-iron-accent text-black font-medium'
                    : 'border-iron-border text-iron-muted hover:border-iron-accent hover:text-iron-accent'
                }`}
              >
                {n}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
